import { render, staticRenderFns } from "./scientific-analysis-detail-modal.vue?vue&type=template&id=2fbe4642&scoped=true&"
import script from "./scientific-analysis-detail-modal.ts?vue&type=script&lang=ts&"
export * from "./scientific-analysis-detail-modal.ts?vue&type=script&lang=ts&"
import style0 from "./scientific-analysis-detail-modal.scss?vue&type=style&index=0&id=2fbe4642&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe4642",
  null
  
)

export default component.exports